import { render, staticRenderFns } from "./SectionWithFilter.vue?vue&type=template&id=9e4d02e6&"
import script from "./SectionWithFilter.vue?vue&type=script&lang=js&"
export * from "./SectionWithFilter.vue?vue&type=script&lang=js&"
import style0 from "./SectionWithFilter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSplitter,QBtn,QCard,QField} from 'quasar'
component.options.components = Object.assign({QSplitter,QBtn,QCard,QField}, component.options.components || {})
